import { Group } from '@mantine/core';

import type { AlertBannerActionsProps } from './alert-banner-types';

export const AlertBannerActions = ({ children }: AlertBannerActionsProps) => <Group gap='sm'>{children}</Group>;
